/**
 * Google Analytics (gtag) — được nạp trong public/index.html.
 * Mọi lệnh gọi đều an toàn khi gtag chưa sẵn sàng hoặc bị chặn.
 */

const GA_MEASUREMENT_ID = 'G-X8S93MW708';

const gtag = (...args) => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag(...args);
    }
};

export const trackEvent = (action, category, label, value) =>
    gtag('event', action, { event_category: category, event_label: label, value });

export const trackPageView = (pageTitle, pageLocation) =>
    gtag('config', GA_MEASUREMENT_ID, { page_title: pageTitle, page_location: pageLocation });

export const trackSearch = (searchTerm) => trackEvent('search', 'user_engagement', searchTerm);

export const trackFilter = (filterType, filterValue) =>
    trackEvent('filter', 'user_engagement', `${filterType}:${filterValue}`);
